module.exports = __webpack_public_path__ + "assets/0020d52c9b123125aaad00f5afb87bd9.jpg";